/* LIST */
export type PROJECT_HAS_ERRORED = typeof PROJECT_HAS_ERRORED
export const PROJECT_HAS_ERRORED = '[Projects] PROJECT_HAS_ERRORED'

export type SET_PROJECT_LOADER = typeof SET_PROJECT_LOADER
export const SET_PROJECT_LOADER = '[Projects] SET_PROJECT_LOADER'

export type GET_PROJECTS = typeof GET_PROJECTS
export const GET_PROJECTS = '[Projects] GET_PROJECTS'

export const GET_PROJECTS_SUCCESS = '[Projects] GET_PROJECTS_SUCCESS'
export type GET_PROJECTS_SUCCESS = typeof GET_PROJECTS_SUCCESS

export const GET_CURRENT_PROJECTS_SUCCESS = '[Projects] GET_CURRENT_PROJECTS_SUCCESS'
export type GET_CURRENT_PROJECTS_SUCCESS = typeof GET_CURRENT_PROJECTS_SUCCESS

export const GET_PROJECTS_LIST_HAS_ERROR = '[Projects] GET_PROJECTS_LIST_HAS_ERROR'
export type GET_PROJECTS_LIST_HAS_ERROR = typeof GET_PROJECTS_LIST_HAS_ERROR

export const CREATE_PROJECT = '[Projects] CREATE_PROJECT'
export type CREATE_PROJECT = typeof CREATE_PROJECT

export const CREATE_PROJECT_SUCCESS = '[Projects] CREATE_PROJECT_SUCCESS'
export type CREATE_PROJECT_SUCCESS = typeof CREATE_PROJECT_SUCCESS

export const UPDATE_PROJECT = '[Projects] UPDATE_PROJECT'
export type UPDATE_PROJECT = typeof UPDATE_PROJECT

export const UPDATE_PROJECT_SUCCESS = '[Projects] UPDATE_PROJECT_SUCCESS'
export type UPDATE_PROJECT_SUCCESS = typeof UPDATE_PROJECT_SUCCESS

export const FILTER_PROJECTS = '[Projects] FILTER_PROJECTS'
export type FILTER_PROJECTS = typeof FILTER_PROJECTS

export const SORT_PROJECTS = '[Projects] SORT_PROJECTS'
export type SORT_PROJECTS = typeof SORT_PROJECTS

export const SET_PROJECT_TYPE_FILTER = '[Projects] SET_PROJECT_TYPE_FILTER'
export type SET_PROJECT_TYPE_FILTER = typeof SET_PROJECT_TYPE_FILTER

export const UPDATE_PROJECT_TYPE_FILTER_COUNTS = '[Projects] UPDATE_PROJECT_TYPE_FILTER_COUNTS'
export type UPDATE_PROJECT_TYPE_FILTER_COUNTS = typeof UPDATE_PROJECT_TYPE_FILTER_COUNTS

export const SELECT_PROJECT = '[Projects] SELECT_PROJECT'
export type SELECT_PROJECT = typeof SELECT_PROJECT

export const DELETE_PROJECT = '[Projects] DELETE_PROJECT'
export type DELETE_PROJECT = typeof DELETE_PROJECT

export const DELETE_PROJECT_SUCCESS = '[Projects] DELETE_PROJECT_SUCCESS'
export type DELETE_PROJECT_SUCCESS = typeof DELETE_PROJECT_SUCCESS

export const UPDATE_PHASES = '[Projects] UPDATE_PHASES'
export type UPDATE_PHASES = typeof UPDATE_PHASES

export const UPDATE_PHASES_SUCCESS = '[Projects] UPDATE_PHASES_SUCCESS'
export type UPDATE_PHASES_SUCCESS = typeof UPDATE_PHASES_SUCCESS

export const UPDATE_BUDGET_CHANGES = '[Projects] UPDATE_BUDGET_CHANGES'
export type UPDATE_BUDGET_CHANGES = typeof UPDATE_BUDGET_CHANGES

export const UPDATE_BUDGET_CHANGES_SUCCESS = '[Projects] UPDATE_BUDGET_CHANGES_SUCCESS'
export type UPDATE_BUDGET_CHANGES_SUCCESS = typeof UPDATE_BUDGET_CHANGES_SUCCESS

export type GET_BUDGET_CHANGES = typeof GET_BUDGET_CHANGES
export const GET_BUDGET_CHANGES = '[Projects] GET_BUDGET_CHANGES'

export type GET_BUDGET_CHANGES_SUCCESS = typeof GET_BUDGET_CHANGES_SUCCESS
export const GET_BUDGET_CHANGES_SUCCESS = '[Projects] GET_BUDGET_CHANGES_SUCCESS'

export type GET_DEPARTMENT_COSTS_CHART_DATA = typeof GET_DEPARTMENT_COSTS_CHART_DATA
export const GET_DEPARTMENT_COSTS_CHART_DATA = '[Projects] GET_DEPARTMENT_COSTS_CHART_DATA'

export type GET_DEPARTMENT_COSTS_CHART_DATA_SUCCESS = typeof GET_DEPARTMENT_COSTS_CHART_DATA_SUCCESS
export const GET_DEPARTMENT_COSTS_CHART_DATA_SUCCESS = '[Projects] GET_DEPARTMENT_COSTS_CHART_DATA_SUCCESS'

export const UPDATE_RECRUITMENT_STATUS_CHANGES = '[Projects] UPDATE_RECRUITMENT_STATUS_CHANGES'
export type UPDATE_RECRUITMENT_STATUS_CHANGES = typeof UPDATE_RECRUITMENT_STATUS_CHANGES

export const UPDATE_RECRUITMENT_STATUS_CHANGES_SUCCESS = '[Projects] UPDATE_RECRUITMENT_STATUS_CHANGES_SUCCESS'
export type UPDATE_RECRUITMENT_STATUS_CHANGES_SUCCESS = typeof UPDATE_RECRUITMENT_STATUS_CHANGES_SUCCESS

export type GET_RECRUITMENT_STATUS_CHANGES = typeof GET_RECRUITMENT_STATUS_CHANGES
export const GET_RECRUITMENT_STATUS_CHANGES = '[Projects] GET_RECRUITMENT_STATUS_CHANGES'

export type GET_RECRUITMENT_STATUS_CHANGES_SUCCESS = typeof GET_RECRUITMENT_STATUS_CHANGES_SUCCESS
export const GET_RECRUITMENT_STATUS_CHANGES_SUCCESS = '[Projects] GET_RECRUITMENT_STATUS_CHANGES_SUCCESS'

export type GET_RECRUITMENT_STATUS_CHART_DATA = typeof GET_RECRUITMENT_STATUS_CHART_DATA
export const GET_RECRUITMENT_STATUS_CHART_DATA = '[Projects] GET_RECRUITMENT_STATUS_CHART_DATA'

export type GET_RECRUITMENT_STATUS_CHART_DATA_SUCCESS = typeof GET_RECRUITMENT_STATUS_CHART_DATA_SUCCESS
export const GET_RECRUITMENT_STATUS_CHART_DATA_SUCCESS = '[Projects] GET_RECRUITMENT_STATUS_CHART_DATA_SUCCESS'

export type SET_RECRUITMENT_TYPE = typeof SET_RECRUITMENT_TYPE
export const SET_RECRUITMENT_TYPE = '[Projects] SET_RECRUITMENT_TYPE'

export type GET_PROJECTS_HEALTH_WIDGET_SUCCESS = typeof GET_PROJECTS_HEALTH_WIDGET_SUCCESS
export const GET_PROJECTS_HEALTH_WIDGET_SUCCESS = '[Projects] GET_PROJECTS_HEALTH_WIDGET_SUCCESS'

export type GET_PROJECTS_HEALTH_WIDGET_HAS_ERROR = typeof GET_PROJECTS_HEALTH_WIDGET_HAS_ERROR
export const GET_PROJECTS_HEALTH_WIDGET_HAS_ERROR = '[Projects] GET_PROJECTS_HEALTH_WIDGET_HAS_ERROR'

// Project Settings
export const SET_PROJECT_SETTINGS_GENERAL_FORM = '[Projects] SET_PROJECT_SETTINGS_GENERAL_FORM'
export type SET_PROJECT_SETTINGS_GENERAL_FORM = typeof SET_PROJECT_SETTINGS_GENERAL_FORM

export const UPDATE_LABELS = '[Projects] UPDATE_LABELS'
export type UPDATE_LABELS = typeof UPDATE_LABELS

export const UPDATE_LABELS_SUCCESS = '[Projects] UPDATE_LABELS_SUCCESS'
export type UPDATE_LABELS_SUCCESS = typeof UPDATE_LABELS_SUCCESS

export const UPDATE_PROJECT_BILLING_COSTS = '[Projects] UPDATE_PROJECT_BILLING_COSTS'
export type UPDATE_PROJECT_BILLING_COSTS = typeof UPDATE_PROJECT_BILLING_COSTS

export const UPDATE_PROJECT_BILLING_COSTS_SUCCESS = '[Projects] UPDATE_PROJECT_BILLING_COSTS_SUCCESS'
export type UPDATE_PROJECT_BILLING_COSTS_SUCCESS = typeof UPDATE_PROJECT_BILLING_COSTS_SUCCESS

export const PROJECT_LABELS_MERGE_TASKS = '[Projects] PROJECT_LABELS_MERGE_TASKS'
export type PROJECT_LABELS_MERGE_TASKS = typeof PROJECT_LABELS_MERGE_TASKS

export const PROJECT_LABELS_MERGE_TASKS_SUCCESS = '[Projects] PROJECT_LABELS_MERGE_TASKS_SUCCESS'
export type PROJECT_LABELS_MERGE_TASKS_SUCCESS = typeof PROJECT_LABELS_MERGE_TASKS_SUCCESS

export const PROJECT_LABELS_MERGE_TASKS_DIRECT_COSTS = '[Projects] PROJECT_LABELS_MERGE_TASKS_DIRECT_COSTS'
export type PROJECT_LABELS_MERGE_TASKS_DIRECT_COSTS = typeof PROJECT_LABELS_MERGE_TASKS_DIRECT_COSTS

export const PROJECT_LABELS_MERGE_TASKS_DIRECT_COSTS_SUCCESS =
  '[Projects] PROJECT_LABELS_MERGE_TASKS_DIRECT_COSTS_SUCCESS'
export type PROJECT_LABELS_MERGE_TASKS_DIRECT_COSTS_SUCCESS = typeof PROJECT_LABELS_MERGE_TASKS_DIRECT_COSTS_SUCCESS

export type GET_PROJECTS_TT_LIST = typeof GET_PROJECTS_TT_LIST
export const GET_PROJECTS_TT_LIST = '[Projects] GET_PROJECTS_TT_LIST'

export const GET_PROJECTS_TT_LIST_SUCCESS = '[Projects] GET_PROJECTS_TT_LIST_SUCCESS'
export type GET_PROJECTS_TT_LIST_SUCCESS = typeof GET_PROJECTS_TT_LIST_SUCCESS

export type CLEAN_PROJECT_STATE = typeof CLEAN_PROJECT_STATE
export const CLEAN_PROJECT_STATE = '[Project] CLEAN_PROJECT_STATE'

/* PLANNING */
export const GET_PROJECT = '[Projects] GET_PROJECT'
export type GET_PROJECT = typeof GET_PROJECT

export const GET_PROJECT_SUCCESS = '[Projects] GET_PROJECT_SUCCESS'
export type GET_PROJECT_SUCCESS = typeof GET_PROJECT_SUCCESS

export const SET_PROJECT_VIEW_TYPE = '[Projects] SET_PROJECT_VIEW_TYPE'
export type SET_PROJECT_VIEW_TYPE = typeof SET_PROJECT_VIEW_TYPE

/* INSIGHTS */
export const SET_INSIGHTS_VIEW_TYPE = '[Projects] SET_INSIGHTS_VIEW_TYPE'
export type SET_INSIGHTS_VIEW_TYPE = typeof SET_INSIGHTS_VIEW_TYPE

export const GET_DEPARTMENT_COST_TREND_CURVE_DATA = '[Projects] GET_DEPARTMENT_COST_TREND_CURVE_DATA'
export type GET_DEPARTMENT_COST_TREND_CURVE_DATA = typeof GET_DEPARTMENT_COST_TREND_CURVE_DATA

export const GET_DEPARTMENT_COST_TREND_CURVE_DATA_SUCCESS = '[Projects] GET_DEPARTMENT_COST_TREND_CURVE_DATA_SUCCESS'
export type GET_DEPARTMENT_COST_TREND_CURVE_DATA_SUCCESS = typeof GET_DEPARTMENT_COST_TREND_CURVE_DATA_SUCCESS

export const GET_DEPARTMENT_EXPENDITURES_TIMELINE = '[Projects] GET_DEPARTMENT_EXPENDITURES_TIMELINE'
export type GET_DEPARTMENT_EXPENDITURES_TIMELINE = typeof GET_DEPARTMENT_EXPENDITURES_TIMELINE

export const GET_DEPARTMENT_EXPENDITURES_TIMELINE_SUCCESS = '[Projects] GET_DEPARTMENT_EXPENDITURES_TIMELINE_SUCCESS'
export type GET_DEPARTMENT_EXPENDITURES_TIMELINE_SUCCESS = typeof GET_DEPARTMENT_EXPENDITURES_TIMELINE_SUCCESS

export const GET_PAGINATED_DEPARTMENT_EXPENDITURES_TIMELINE =
  '[Projects] GET_PAGINATED_DEPARTMENT_EXPENDITURES_TIMELINE'
export type GET_PAGINATED_DEPARTMENT_EXPENDITURES_TIMELINE = typeof GET_PAGINATED_DEPARTMENT_EXPENDITURES_TIMELINE

export const GET_PAGINATED_DEPARTMENT_EXPENDITURES_TIMELINES_SUCCESS =
  '[Projects] GET_PAGINATED_DEPARTMENT_EXPENDITURES_TIMELINES_SUCCESS'
export type GET_PAGINATED_DEPARTMENT_EXPENDITURES_TIMELINES_SUCCESS =
  typeof GET_PAGINATED_DEPARTMENT_EXPENDITURES_TIMELINES_SUCCESS

export const SET_PAGINATED_DEPARTMENT_EXPENDITURES_TIMELINES_ACTIVE_PAGE =
  '[Projects] SET_PAGINATED_DEPARTMENT_EXPENDITURES_TIMELINES_ACTIVE_PAGE'
export type SET_PAGINATED_DEPARTMENT_EXPENDITURES_TIMELINES_ACTIVE_PAGE =
  typeof SET_PAGINATED_DEPARTMENT_EXPENDITURES_TIMELINES_ACTIVE_PAGE

export const GET_PROJECT_EXPENDITURES_BURNDOWN = '[Projects] GET_PROJECT_EXPENDITURES_BURNDOWN'
export type GET_PROJECT_EXPENDITURES_BURNDOWN = typeof GET_PROJECT_EXPENDITURES_BURNDOWN

export const GET_PROJECT_EXPENDITURES_BURNDOWN_SUCCESS = '[Projects] GET_PROJECT_EXPENDITURES_BURNDOWN_SUCCESS'
export type GET_PROJECT_EXPENDITURES_BURNDOWN_SUCCESS = typeof GET_PROJECT_EXPENDITURES_BURNDOWN_SUCCESS

export const GET_EXPENDITURES_BY_LABELS = '[Projects] GET_EXPENDITURES_BY_LABELS'
export type GET_EXPENDITURES_BY_LABELS = typeof GET_EXPENDITURES_BY_LABELS

export const GET_EXPENDITURES_BY_LABELS_SUCCESS = '[Projects] GET_EXPENDITURES_BY_LABELS_SUCCESS'
export type GET_EXPENDITURES_BY_LABELS_SUCCESS = typeof GET_EXPENDITURES_BY_LABELS_SUCCESS

export const GET_EXPENDITURES_BY_TASKS = '[Projects] GET_EXPENDITURES_BY_TASKS'
export type GET_EXPENDITURES_BY_TASKS = typeof GET_EXPENDITURES_BY_TASKS

export const GET_EXPENDITURES_BY_TASKS_SUCCESS = '[Projects] GET_EXPENDITURES_BY_TASKS_SUCCESS'
export type GET_EXPENDITURES_BY_TASKS_SUCCESS = typeof GET_EXPENDITURES_BY_TASKS_SUCCESS

export const GET_PAGINATED_EXPENDITURES_BY_TASKS = '[Projects] GET_PAGINATED_EXPENDITURES_BY_TASKS'
export type GET_PAGINATED_EXPENDITURES_BY_TASKS = typeof GET_PAGINATED_EXPENDITURES_BY_TASKS

export const GET_PAGINATED_EXPENDITURES_BY_TASKS_SUCCESS = '[Projects] GET_PAGINATED_EXPENDITURES_BY_TASKS_SUCCESS'
export type GET_PAGINATED_EXPENDITURES_BY_TASKS_SUCCESS = typeof GET_PAGINATED_EXPENDITURES_BY_TASKS_SUCCESS

export const SET_PAGINATED_EXPENDITURES_BY_TASKS_ACTIVE_PAGE =
  '[Projects] SET_PAGINATED_EXPENDITURES_BY_TASKS_ACTIVE_PAGE'
export type SET_PAGINATED_EXPENDITURES_BY_TASKS_ACTIVE_PAGE = typeof SET_PAGINATED_EXPENDITURES_BY_TASKS_ACTIVE_PAGE

export const GET_COST_BY_MONTHS = '[Projects] GET_COST_BY_MONTHS'
export type GET_COST_BY_MONTHS = typeof GET_COST_BY_MONTHS

export const GET_COST_BY_MONTHS_SUCCESS = '[Projects] GET_COST_BY_MONTHS_SUCCESS'
export type GET_COST_BY_MONTHS_SUCCESS = typeof GET_COST_BY_MONTHS_SUCCESS

export const GET_PROJECT_TIME_TRACKING_BY_LABELS = '[Projects] GET_PROJECT_TIME_TRACKING_BY_LABELS'
export type GET_PROJECT_TIME_TRACKING_BY_LABELS = typeof GET_PROJECT_TIME_TRACKING_BY_LABELS

export const GET_PROJECT_TIME_TRACKING_BY_LABELS_SUCCESS = '[Projects] GET_PROJECT_TIME_TRACKING_BY_LABELS_SUCCESS'
export type GET_PROJECT_TIME_TRACKING_BY_LABELS_SUCCESS = typeof GET_PROJECT_TIME_TRACKING_BY_LABELS_SUCCESS

export const GET_PROJECT_TIME_TRACKING_LABELS = '[Projects] GET_PROJECT_TIME_TRACKING_LABELS'
export type GET_PROJECT_TIME_TRACKING_LABELS = typeof GET_PROJECT_TIME_TRACKING_LABELS

export const GET_PROJECT_TIME_TRACKING_LABELS_SUCCESS = '[Projects] GET_PROJECT_TIME_TRACKING_LABELS_SUCCESS'
export type GET_PROJECT_TIME_TRACKING_LABELS_SUCCESS = typeof GET_PROJECT_TIME_TRACKING_LABELS_SUCCESS

export const GET_PAGINATED_PROJECT_TIME_TRACKING_LABELS = '[Projects] GET_PAGINATED_PROJECT_TIME_TRACKING_LABELS'
export type GET_PAGINATED_PROJECT_TIME_TRACKING_LABELS = typeof GET_PAGINATED_PROJECT_TIME_TRACKING_LABELS

export const GET_PAGINATED_PROJECT_TIME_TRACKING_LABELS_SUCCESS =
  '[Projects] GET_PAGINATED_PROJECT_TIME_TRACKING_LABELS_SUCCESS'
export type GET_PAGINATED_PROJECT_TIME_TRACKING_LABELS_SUCCESS =
  typeof GET_PAGINATED_PROJECT_TIME_TRACKING_LABELS_SUCCESS

export const SET_PAGINATED_PROJECT_TIME_TRACKING_LABELS_ACTIVE_PAGE =
  '[Projects] SET_PAGINATED_PROJECT_TIME_TRACKING_LABELS_ACTIVE_PAGE'
export type SET_PAGINATED_PROJECT_TIME_TRACKING_LABELS_ACTIVE_PAGE =
  typeof SET_PAGINATED_PROJECT_TIME_TRACKING_LABELS_ACTIVE_PAGE

export const GET_PROJECT_TIME_TRACKING_TASKS = '[Projects] GET_PROJECT_TIME_TRACKING_TASKS'
export type GET_PROJECT_TIME_TRACKING_TASKS = typeof GET_PROJECT_TIME_TRACKING_TASKS

export const GET_PROJECT_TIME_TRACKING_TASKS_SUCCESS = '[Projects] GET_PROJECT_TIME_TRACKING_TASKS_SUCCESS'
export type GET_PROJECT_TIME_TRACKING_TASKS_SUCCESS = typeof GET_PROJECT_TIME_TRACKING_TASKS_SUCCESS

export const GET_PAGINATED_PROJECT_TIME_TRACKING_TASKS = '[Projects] GET_PAGINATED_PROJECT_TIME_TRACKING_TASKS'
export type GET_PAGINATED_PROJECT_TIME_TRACKING_TASKS = typeof GET_PAGINATED_PROJECT_TIME_TRACKING_TASKS

export const GET_PAGINATED_PROJECT_TIME_TRACKING_TASKS_SUCCESS =
  '[Projects] GET_PAGINATED_PROJECT_TIME_TRACKING_TASKS_SUCCESS'
export type GET_PAGINATED_PROJECT_TIME_TRACKING_TASKS_SUCCESS = typeof GET_PAGINATED_PROJECT_TIME_TRACKING_TASKS_SUCCESS

export const SET_PAGINATED_PROJECT_TIME_TRACKING_TASKS_ACTIVE_PAGE =
  '[Projects] SET_PAGINATED_PROJECT_TIME_TRACKING_TASKS_ACTIVE_PAGE'
export type SET_PAGINATED_PROJECT_TIME_TRACKING_TASKS_ACTIVE_PAGE =
  typeof SET_PAGINATED_PROJECT_TIME_TRACKING_TASKS_ACTIVE_PAGE

export const GET_COST_BY_PHASES = '[Projects] GET_COST_BY_PHASES'
export type GET_COST_BY_PHASES = typeof GET_COST_BY_PHASES

export const GET_COST_BY_PHASES_SUCCESS = '[Projects] GET_COST_BY_PHASES_SUCCESS'
export type GET_COST_BY_PHASES_SUCCESS = typeof GET_COST_BY_PHASES_SUCCESS

export const SEARCH_DEPARTMENT_COST_UTILIZATION = '[Projects] SEARCH_DEPARTMENT_COST_UTILIZATION'
export type SEARCH_DEPARTMENT_COST_UTILIZATION = typeof SEARCH_DEPARTMENT_COST_UTILIZATION

export const SEARCH_EXPENDITURES_BY_TASKS = '[Projects] SEARCH_EXPENDITURES_BY_TASKS'
export type SEARCH_EXPENDITURES_BY_TASKS = typeof SEARCH_EXPENDITURES_BY_TASKS

export const GET_TRACKED_HOURS_BY_DEP = '[Projects] GET_TRACKED_HOURS_BY_DEP'
export type GET_TRACKED_HOURS_BY_DEP = typeof GET_TRACKED_HOURS_BY_DEP

export const GET_TRACKED_HOURS_BY_DEP_SUCCESS = '[Projects] GET_TRACKED_HOURS_BY_DEP_SUCCESS'
export type GET_TRACKED_HOURS_BY_DEP_SUCCESS = typeof GET_TRACKED_HOURS_BY_DEP_SUCCESS

export const GET_COST_BY_SUPPLIER = '[Projects] GET_COST_BY_SUPPLIER'
export type GET_COST_BY_SUPPLIER = typeof GET_COST_BY_SUPPLIER

export const GET_COST_BY_SUPPLIER_SUCCESS = '[Projects] GET_COST_BY_SUPPLIER_SUCCESS'
export type GET_COST_BY_SUPPLIER_SUCCESS = typeof GET_COST_BY_SUPPLIER_SUCCESS

export const SET_COST_BY_SUPPLIER = '[Projects] SET_COST_BY_SUPPLIER'
export type SET_COST_BY_SUPPLIER = typeof SET_COST_BY_SUPPLIER

export const GET_PAYMENTS_BY_TIME_CHART_DATA = '[Projects] GET_PAYMENTS_BY_TIME_CHART_DATA'
export type GET_PAYMENTS_BY_TIME_CHART_DATA = typeof GET_PAYMENTS_BY_TIME_CHART_DATA

export const GET_PAYMENTS_BY_TIME_CHART_DATA_SUCCESS = '[Projects] GET_PAYMENTS_BY_TIME_CHART_DATA_SUCCESS'
export type GET_PAYMENTS_BY_TIME_CHART_DATA_SUCCESS = typeof GET_PAYMENTS_BY_TIME_CHART_DATA_SUCCESS

export const GET_PAYMENT_FORECAST_CHART_DATA = '[Projects] GET_PAYMENT_FORECAST_CHART_DATA'
export type GET_PAYMENT_FORECAST_CHART_DATA = typeof GET_PAYMENT_FORECAST_CHART_DATA

export const GET_PAYMENT_FORECAST_CHART_DATA_SUCCESS = '[Projects] GET_PAYMENT_FORECAST_CHART_DATA_SUCCESS'
export type GET_PAYMENT_FORECAST_CHART_DATA_SUCCESS = typeof GET_PAYMENT_FORECAST_CHART_DATA_SUCCESS

export const GET_RECEIPT_FORECAST_CHART_DATA = '[Projects] GET_RECEIPT_FORECAST_CHART_DATA'
export type GET_RECEIPT_FORECAST_CHART_DATA = typeof GET_RECEIPT_FORECAST_CHART_DATA

export const GET_RECEIPT_FORECAST_CHART_DATA_SUCCESS = '[Projects] GET_RECEIPT_FORECAST_CHART_DATA_SUCCESS'
export type GET_RECEIPT_FORECAST_CHART_DATA_SUCCESS = typeof GET_RECEIPT_FORECAST_CHART_DATA_SUCCESS

export const GET_EXPENDITURE_PHASING_CHART_DATA = '[Projects] GET_EXPENDITURE_PHASING_CHART_DATA'
export type GET_EXPENDITURE_PHASING_CHART_DATA = typeof GET_EXPENDITURE_PHASING_CHART_DATA

export const GET_EXPENDITURE_PHASING_CHART_DATA_SUCCESS = '[Projects] GET_EXPENDITURE_PHASING_CHART_DATA_SUCCESS'
export type GET_EXPENDITURE_PHASING_CHART_DATA_SUCCESS = typeof GET_EXPENDITURE_PHASING_CHART_DATA_SUCCESS

export const GET_COST_DEVELOPMENT_CHART_DATA = '[Projects] GET_COST_DEVELOPMENT_CHART_DATA'
export type GET_COST_DEVELOPMENT_CHART_DATA = typeof GET_COST_DEVELOPMENT_CHART_DATA

export const GET_COST_DEVELOPMENT_CHART_DATA_SUCCESS = '[Projects] GET_COST_DEVELOPMENT_CHART_DATA_SUCCESS'
export type GET_COST_DEVELOPMENT_CHART_DATA_SUCCESS = typeof GET_COST_DEVELOPMENT_CHART_DATA_SUCCESS

export const GET_MARGIN_DEVELOPMENT_CHART_DATA = '[Projects] GET_MARGIN_DEVELOPMENT_CHART_DATA'
export type GET_MARGIN_DEVELOPMENT_CHART_DATA = typeof GET_MARGIN_DEVELOPMENT_CHART_DATA

export const GET_MARGIN_DEVELOPMENT_CHART_DATA_SUCCESS = '[Projects] GET_MARGIN_DEVELOPMENT_CHART_DATA_SUCCESS'
export type GET_MARGIN_DEVELOPMENT_CHART_DATA_SUCCESS = typeof GET_MARGIN_DEVELOPMENT_CHART_DATA_SUCCESS

export const SET_PAYMENTS_BY_TIME_PERIOD = '[Projects] SET_PAYMENTS_BY_TIME_PERIOD'
export type SET_PAYMENTS_BY_TIME_PERIOD = typeof SET_PAYMENTS_BY_TIME_PERIOD

export const SET_PAYMENT_FORECAST_TIME_PERIOD = '[Projects] SET_PAYMENT_FORECAST_TIME_PERIOD'
export type SET_PAYMENT_FORECAST_TIME_PERIOD = typeof SET_PAYMENT_FORECAST_TIME_PERIOD

export const SET_RECEIPT_FORECAST_TIME_PERIOD = '[Projects] SET_RECEIPT_FORECAST_TIME_PERIOD'
export type SET_RECEIPT_FORECAST_TIME_PERIOD = typeof SET_RECEIPT_FORECAST_TIME_PERIOD

export const SET_EXPENDITURE_PHASING_TIME_PERIOD = '[Projects] SET_EXPENDITURE_PHASING_TIME_PERIOD'
export type SET_EXPENDITURE_PHASING_TIME_PERIOD = typeof SET_EXPENDITURE_PHASING_TIME_PERIOD

export const SET_TIME_PERIOD_DEP_COST = '[Projects] SET_TIME_PERIOD_DEP_COST'
export type SET_TIME_PERIOD_DEP_COST = typeof SET_TIME_PERIOD_DEP_COST

export const SET_YEAR_DEP_COST = '[Projects] SET_YEAR_DEP_COST'
export type SET_YEAR_DEP_COST = typeof SET_YEAR_DEP_COST

export const SET_TYPE_DEP_COST = '[Projects] SET_TYPE_DEP_COST'
export type SET_TYPE_DEP_COST = typeof SET_TYPE_DEP_COST

export const SET_YEAR_PROJ_COST_DEV = '[Projects] SET_YEAR_PROJ_COST_DEV'
export type SET_YEAR_PROJ_COST_DEV = typeof SET_YEAR_PROJ_COST_DEV

export const SET_TYPE_PROJ_COST_DEV = '[Projects] SET_TYPE_PROJ_COST_DEV'
export type SET_TYPE_PROJ_COST_DEV = typeof SET_TYPE_PROJ_COST_DEV

export const SET_COST_DEVELOPMENT_STATUS = '[Projects] SET_COST_DEVELOPMENT_STATUS'
export type SET_COST_DEVELOPMENT_STATUS = typeof SET_COST_DEVELOPMENT_STATUS

export const SET_TYPE_RECRUITMENT_COSTS = '[Projects] SET_TYPE_RECRUITMENT_COSTS'
export type SET_TYPE_RECRUITMENT_COSTS = typeof SET_TYPE_RECRUITMENT_COSTS

export const SET_YEAR_RECRUITMENT_COSTS = '[Projects] SET_YEAR_RECRUITMENT_COSTS'
export type SET_YEAR_RECRUITMENT_COSTS = typeof SET_YEAR_RECRUITMENT_COSTS

export const SET_YEAR_EXPENDITURE_PHASING = '[Projects] SET_YEAR_EXPENDITURE_PHASING'
export type SET_YEAR_EXPENDITURE_PHASING = typeof SET_YEAR_EXPENDITURE_PHASING

export const SET_TYPE_MARGIN_DEVELOPMENT = '[Projects] SET_TYPE_MARGIN_DEVELOPMENT'
export type SET_TYPE_MARGIN_DEVELOPMENT = typeof SET_TYPE_MARGIN_DEVELOPMENT

export const SET_YEAR_PAYMENTS_BY_TYPE = '[Projects] SET_YEAR_PAYMENTS_BY_TYPE'
export type SET_YEAR_PAYMENTS_BY_TYPE = typeof SET_YEAR_PAYMENTS_BY_TYPE

export const SET_YEAR_PAYMENT_FORECAST = '[Projects] SET_YEAR_PAYMENT_FORECAST'
export type SET_YEAR_PAYMENT_FORECAST = typeof SET_YEAR_PAYMENT_FORECAST

export const SET_YEAR_RECEIPT_FORECAST = '[Projects] SET_YEAR_RECEIPT_FORECAST'
export type SET_YEAR_RECEIPT_FORECAST = typeof SET_YEAR_RECEIPT_FORECAST

export const GET_RESTRICTED_PHASES = '[Projects] GET_RESTRICTED_PHASES'
export type GET_RESTRICTED_PHASES = typeof GET_RESTRICTED_PHASES

export const GET_RESTRICTED_PHASES_SUCCESS = '[Projects] GET_RESTRICTED_PHASES_SUCCESS'
export type GET_RESTRICTED_PHASES_SUCCESS = typeof GET_RESTRICTED_PHASES_SUCCESS

/* PROJECT TIME TRACKING REPORT */
export const GET_PROJECT_TIME_TRACKING = '[Projects] GET_PROJECT_TIME_TRACKING'
export type GET_PROJECT_TIME_TRACKING = typeof GET_PROJECT_TIME_TRACKING

export const GET_PROJECT_TIME_TRACKING_SUCCESS = '[Projects] GET_PROJECT_TIME_TRACKING_SUCCESS'
export type GET_PROJECT_TIME_TRACKING_SUCCESS = typeof GET_PROJECT_TIME_TRACKING_SUCCESS

export const GET_PAGINATED_TIME_TRACKING = '[Projects] GET_PAGINATED_TIME_TRACKING'
export type GET_PAGINATED_TIME_TRACKING = typeof GET_PAGINATED_TIME_TRACKING

export const GET_PAGINATED_TIME_TRACKING_SUCCESS = '[Projects] GET_PAGINATED_TIME_TRACKING_SUCCESS'
export type GET_PAGINATED_TIME_TRACKING_SUCCESS = typeof GET_PAGINATED_TIME_TRACKING_SUCCESS

export const SORT_TIME_TRACKING_REPORT = '[Projects] SORT_TIME_TRACKING_REPORT'
export type SORT_TIME_TRACKING_REPORT = typeof SORT_TIME_TRACKING_REPORT


export const SET_PAGINATED_TIME_TRACKING_ACTIVE_PAGE = '[Projects] SET_PAGINATED_TIME_TRACKING_ACTIVE_PAGE'
export type SET_PAGINATED_TIME_TRACKING_ACTIVE_PAGE = typeof SET_PAGINATED_TIME_TRACKING_ACTIVE_PAGE

export const SEARCH_PROJECT_TIME_TRACKING = '[Projects] SEARCH_PROJECT_TIME_TRACKING'
export type SEARCH_PROJECT_TIME_TRACKING = typeof SEARCH_PROJECT_TIME_TRACKING

export const GET_DEP_HOURS_UTIL = '[Projects] GET_DEP_HOURS_UTIL'
export type GET_DEP_HOURS_UTIL = typeof GET_DEP_HOURS_UTIL

export const GET_DEP_HOURS_UTIL_SUCCESS = '[Projects] GET_DEP_HOURS_UTIL_SUCCESS'
export type GET_DEP_HOURS_UTIL_SUCCESS = typeof GET_DEP_HOURS_UTIL_SUCCESS

export const GET_DEP_TREND_HOURS = '[Projects] GET_DEP_TREND_HOURS'
export type GET_DEP_TREND_HOURS = typeof GET_DEP_TREND_HOURS

export const GET_DEP_TREND_HOURS_SUCCESS = '[Projects] GET_DEP_TREND_HOURS_SUCCESS'
export type GET_DEP_TREND_HOURS_SUCCESS = typeof GET_DEP_TREND_HOURS_SUCCESS
/* END */

/** WIZARD */
export const WIZARD_HAS_ERRORED = '[Projects] WIZARD_HAS_ERRORED'
export type WIZARD_HAS_ERRORED = typeof WIZARD_HAS_ERRORED

export const SET_WIZARD_STEP = '[Projects] SET_WIZARD_STEP'
export type SET_WIZARD_STEP = typeof SET_WIZARD_STEP

export const SET_PROJECT_WIZARD_DATA = '[Projects] SET_PROJECT_WIZARD_DATA'
export type SET_PROJECT_WIZARD_DATA = typeof SET_PROJECT_WIZARD_DATA

export const SET_WIZARD_FINISHED_STEPS = '[Projects] SET_WIZARD_FINISHED_STEPS'
export type SET_WIZARD_FINISHED_STEPS = typeof SET_WIZARD_FINISHED_STEPS

export const WIZARD_CREATE_PROJECT = '[Projects] WIZARD_CREATE_PROJECT'
export type WIZARD_CREATE_PROJECT = typeof WIZARD_CREATE_PROJECT

export const WIZARD_CREATE_PROJECT_SUCCESS = '[Projects] WIZARD_CREATE_PROJECT_SUCCESS'
export type WIZARD_CREATE_PROJECT_SUCCESS = typeof WIZARD_CREATE_PROJECT_SUCCESS

/** ACTIVITIES LIST */
export const ACTIVITIES_HAS_ERRORED = '[Activities] ACTIVITIES_HAS_ERRORED'
export type ACTIVITIES_HAS_ERRORED = typeof ACTIVITIES_HAS_ERRORED

export const GET_ACTIVITIES = '[Activities] GET_ACTIVITIES'
export type GET_ACTIVITIES = typeof GET_ACTIVITIES

export const GET_ACTIVITIES_SUCCESS = '[Activities] GET_ACTIVITIES_SUCCESS'
export type GET_ACTIVITIES_SUCCESS = typeof GET_ACTIVITIES_SUCCESS

export const GET_PAGINATED_ACTIVITIES = '[Activities] GET_PAGINATED_ACTIVITIES'
export type GET_PAGINATED_ACTIVITIES = typeof GET_PAGINATED_ACTIVITIES

export const GET_PAGINATED_ACTIVITIES_SUCCESS = '[Activities] GET_PAGINATED_ACTIVITIES_SUCCESS'
export type GET_PAGINATED_ACTIVITIES_SUCCESS = typeof GET_PAGINATED_ACTIVITIES_SUCCESS

export const SET_PAGINATED_ACTIVITIES_ACTIVE_PAGE = '[Activities] SET_PAGINATED_ACTIVITIES_ACTIVE_PAGE'
export type SET_PAGINATED_ACTIVITIES_ACTIVE_PAGE = typeof SET_PAGINATED_ACTIVITIES_ACTIVE_PAGE

export type ACTIVITY_HAS_ERRORED = typeof ACTIVITY_HAS_ERRORED
export const ACTIVITY_HAS_ERRORED = '[Activities] ACTIVITY_HAS_ERRORED'

export const GET_ACTIVITY = '[Activities] GET_ACTIVITY'
export type GET_ACTIVITY = typeof GET_ACTIVITY

export const GET_ACTIVITY_SUCCESS = '[Activities] GET_ACTIVITY_SUCCESS'
export type GET_ACTIVITY_SUCCESS = typeof GET_ACTIVITY_SUCCESS

export const SET_SELECTED_ACTIVITY = '[Activities] SET_SELECTED_ACTIVITY'
export type SET_SELECTED_ACTIVITY = typeof SET_SELECTED_ACTIVITY

export const UPDATE_ACTIVITY = '[Activities] UPDATE_ACTIVITY'
export type UPDATE_ACTIVITY = typeof UPDATE_ACTIVITY

export const UPDATE_ACTIVITY_SUCCESS = '[Activities] UPDATE_ACTIVITY_SUCCESS'
export type UPDATE_ACTIVITY_SUCCESS = typeof UPDATE_ACTIVITY_SUCCESS

export const CREATE_ACTIVITY = '[Activities] CREATE_ACTIVITY'
export type CREATE_ACTIVITY = typeof CREATE_ACTIVITY

export const CREATE_ACTIVITY_SUCCESS = '[Activities] CREATE_ACTIVITY_SUCCESS'
export type CREATE_ACTIVITY_SUCCESS = typeof CREATE_ACTIVITY_SUCCESS

export const SET_ACTIVITY_DATES = '[Activities] SET_ACTIVITY_DATES'
export type SET_ACTIVITY_DATES = typeof SET_ACTIVITY_DATES

export const SEARCH_ACTIVITIES = '[Activities] SEARCH_ACTIVITIES'
export type SEARCH_ACTIVITIES = typeof SEARCH_ACTIVITIES

export const SORT_ACTS = '[Activities] SORT_ACTS'
export type SORT_ACTS = typeof SORT_ACTS

export const SORT_ACTS_IN_DANGER = '[Activities] SORT_ACTS_IN_DANGER'
export type SORT_ACTS_IN_DANGER = typeof SORT_ACTS_IN_DANGER

export const SET_ACT_FILTERS = '[Activities] SET_ACT_FILTERS'
export type SET_ACT_FILTERS = typeof SET_ACT_FILTERS

export const GET_ACT_FILTERS = '[Activities] GET_ACT_FILTERS'
export type GET_ACT_FILTERS = typeof GET_ACT_FILTERS

export const CLEAR_ACT_FILTERS = '[Activities] CLEAR_ACT_FILTERS'
export type CLEAR_ACT_FILTERS = typeof CLEAR_ACT_FILTERS

export const GET_ACT_FILTERS_SUCCESS = '[Activities] GET_ACT_FILTERS_SUCCESS'
export type GET_ACT_FILTERS_SUCCESS = typeof GET_ACT_FILTERS_SUCCESS

export const GET_ACT_HISTORY = '[Activities] GET_ACT_HISTORY'
export type GET_ACT_HISTORY = typeof GET_ACT_HISTORY

export const GET_ACT_HISTORY_SUCCESS = '[Activities] GET_ACT_HISTORY_SUCCESS'
export type GET_ACT_HISTORY_SUCCESS = typeof GET_ACT_HISTORY_SUCCESS

export const RESET_ACT_HISTORY = '[Activities] RESET_ACT_HISTORY'
export type RESET_ACT_HISTORY = typeof RESET_ACT_HISTORY

export const DELETE_ACTIVITY = '[Activities] DELETE_ACTIVITY'
export type DELETE_ACTIVITY = typeof DELETE_ACTIVITY

export const DELETE_ACTIVITY_SUCCESS = '[Activities] DELETE_ACTIVITY_SUCCESS'
export type DELETE_ACTIVITY_SUCCESS = typeof DELETE_ACTIVITY_SUCCESS

export const SET_OPEN_ACT_DETAILS_MODAL = '[Activities] SET_OPEN_ACT_DETAILS_MODAL'
export type SET_OPEN_ACT_DETAILS_MODAL = typeof SET_OPEN_ACT_DETAILS_MODAL

export const SET_DRAGGABLE_INDICATOR_ACT_SUCCESS = '[Activities] SET_DRAGGABLE_INDICATOR_ACT_SUCCESS'
export type SET_DRAGGABLE_INDICATOR_ACT_SUCCESS = typeof SET_DRAGGABLE_INDICATOR_ACT_SUCCESS

export const EXPORT_PROJECT_ACTIVITIES = '[Activities] EXPORT_PROJECT_ACTIVITIES'
export type EXPORT_PROJECT_ACTIVITIES = typeof EXPORT_PROJECT_ACTIVITIES

export const EXPORT_PROJECT_ACTIVITIES_SUCCESS = '[Activities] EXPORT_PROJECT_ACTIVITIES_SUCCESS'
export type EXPORT_PROJECT_ACTIVITIES_SUCCESS = typeof EXPORT_PROJECT_ACTIVITIES_SUCCESS

/** SERVICE PROVIDER PROJECT -- DIRECT AND PASS TROUGH COSTS */
export const COST_HAS_ERRORED = '[ServiceProviderCosts] COST_HAS_ERRORED'
export type COST_HAS_ERRORED = typeof COST_HAS_ERRORED

export const GET_DIRECT_COSTS = '[ServiceProviderCosts] GET_DIRECT_COSTS'
export type GET_DIRECT_COSTS = typeof GET_DIRECT_COSTS

export const GET_DIRECT_COSTS_SUCCESS = '[ServiceProviderCosts] GET_DIRECT_COSTS_SUCCESS'
export type GET_DIRECT_COSTS_SUCCESS = typeof GET_DIRECT_COSTS_SUCCESS

export const GET_PAGINATED_DIRECT_COSTS = '[ServiceProviderCosts] GET_PAGINATED_DIRECT_COSTS'
export type GET_PAGINATED_DIRECT_COSTS = typeof GET_PAGINATED_DIRECT_COSTS

export const GET_PAGINATED_DIRECT_COSTS_SUCCESS = '[ServiceProviderCosts] GET_PAGINATED_DIRECT_COSTS_SUCCESS'
export type GET_PAGINATED_DIRECT_COSTS_SUCCESS = typeof GET_PAGINATED_DIRECT_COSTS_SUCCESS

export const SET_PAGINATED_DIRECT_COSTS_ACTIVE_PAGE = '[ServiceProviderCosts] SET_PAGINATED_DIRECT_COSTS_ACTIVE_PAGE'
export type SET_PAGINATED_DIRECT_COSTS_ACTIVE_PAGE = typeof SET_PAGINATED_DIRECT_COSTS_ACTIVE_PAGE

export const UPDATE_DIRECT_COST = '[ServiceProviderCosts] UPDATE_DIRECT_COST'
export type UPDATE_DIRECT_COST = typeof UPDATE_DIRECT_COST

export const UPDATE_DIRECT_COST_SUCCESS = '[ServiceProviderCosts] UPDATE_DIRECT_COST_SUCCESS'
export type UPDATE_DIRECT_COST_SUCCESS = typeof UPDATE_DIRECT_COST_SUCCESS

export const CREATE_DIRECT_COST = '[ServiceProviderCosts] CREATE_DIRECT_COST'
export type CREATE_DIRECT_COST = typeof CREATE_DIRECT_COST

export const CREATE_DIRECT_COST_SUCCESS = '[ServiceProviderCosts] CREATE_DIRECT_COST_SUCCESS'
export type CREATE_DIRECT_COST_SUCCESS = typeof CREATE_DIRECT_COST_SUCCESS

export const UPDATE_PASS_TROUGH_COST = '[ServiceProviderCosts] UPDATE_PASS_TROUGH_COST'
export type UPDATE_PASS_TROUGH_COST = typeof UPDATE_PASS_TROUGH_COST

export const UPDATE_PASS_TROUGH_COST_SUCCESS = '[ServiceProviderCosts] UPDATE_PASS_TROUGH_COST_SUCCESS'
export type UPDATE_PASS_TROUGH_COST_SUCCESS = typeof UPDATE_PASS_TROUGH_COST_SUCCESS

export const CREATE_PASS_TROUGH_COST = '[ServiceProviderCosts] CREATE_PASS_TROUGH_COST'
export type CREATE_PASS_TROUGH_COST = typeof CREATE_PASS_TROUGH_COST

export const CREATE_PASS_TROUGH_COST_SUCCESS = '[ServiceProviderCosts] CREATE_PASS_TROUGH_COST_SUCCESS'
export type CREATE_PASS_TROUGH_COST_SUCCESS = typeof CREATE_PASS_TROUGH_COST_SUCCESS

export const GET_PASS_TROUGH_COSTS = '[ServiceProviderCosts] GET_PASS_TROUGH_COSTS'
export type GET_PASS_TROUGH_COSTS = typeof GET_PASS_TROUGH_COSTS

export const GET_PASS_TROUGH_COSTS_SUCCESS = '[ServiceProviderCosts] GET_PASS_TROUGH_COSTS_SUCCESS'
export type GET_PASS_TROUGH_COSTS_SUCCESS = typeof GET_PASS_TROUGH_COSTS_SUCCESS

export const GET_DIRECT_COST = '[ServiceProviderCosts] GET_DIRECT_COST'
export type GET_DIRECT_COST = typeof GET_DIRECT_COST

export const GET_DIRECT_COST_SUCCESS = '[ServiceProviderCosts] GET_DIRECT_COST_SUCCESS'
export type GET_DIRECT_COST_SUCCESS = typeof GET_DIRECT_COST_SUCCESS

export const GET_PASS_TROUGH_COST = '[ServiceProviderCosts] GET_PASS_TROUGH_COST'
export type GET_PASS_TROUGH_COST = typeof GET_PASS_TROUGH_COST

export const GET_PASS_TROUGH_COST_SUCCESS = '[ServiceProviderCosts] GET_PASS_TROUGH_COST_SUCCESS'
export type GET_PASS_TROUGH_COST_SUCCESS = typeof GET_PASS_TROUGH_COST_SUCCESS

export const SET_SELECTED_COST = '[ServiceProviderCosts] SET_SELECTED_COST'
export type SET_SELECTED_COST = typeof SET_SELECTED_COST

export const SET_COSTS_FILTERS = '[ServiceProviderCosts] SET_COSTS_FILTERS'
export type SET_COSTS_FILTERS = typeof SET_COSTS_FILTERS

export const CLEAR_COST_FILTERS = '[ServiceProviderCosts] CLEAR_COST_FILTERS'
export type CLEAR_COST_FILTERS = typeof CLEAR_COST_FILTERS

export const GET_COSTS_FILTERS = '[ServiceProviderCosts] GET_COSTS_FILTERS'
export type GET_COSTS_FILTERS = typeof GET_COSTS_FILTERS

export const GET_COSTS_FILTERS_SUCCESS = '[ServiceProviderCosts] GET_COSTS_FILTERS_SUCCESS'
export type GET_COSTS_FILTERS_SUCCESS = typeof GET_COSTS_FILTERS_SUCCESS

export const SORT_COSTS = '[ServiceProviderCosts] SORT_COSTS'
export type SORT_COSTS = typeof SORT_COSTS

export const SORT_DC_IN_DANGER = '[ServiceProviderCosts] SORT_DC_IN_DANGER'
export type SORT_DC_IN_DANGER = typeof SORT_DC_IN_DANGER

export const SEARCH_COSTS = '[ServiceProviderCosts] SEARCH_COSTS'
export type SEARCH_COSTS = typeof SEARCH_COSTS

export const SET_OPEN_COST_DETAILS_MODAL = '[ServiceProviderCosts] SET_OPEN_COST_DETAILS_MODAL'
export type SET_OPEN_COST_DETAILS_MODAL = typeof SET_OPEN_COST_DETAILS_MODAL

export const GET_DIRECT_COST_HISTORY = '[ServiceProviderCosts] GET_DIRECT_COST_HISTORY'
export type GET_DIRECT_COST_HISTORY = typeof GET_DIRECT_COST_HISTORY

export const GET_DIRECT_COST_HISTORY_SUCCESS = '[ServiceProviderCosts] GET_DIRECT_COST_HISTORY_SUCCESS'
export type GET_DIRECT_COST_HISTORY_SUCCESS = typeof GET_DIRECT_COST_HISTORY_SUCCESS

export const RESET_DIRECT_COST_HISTORY = '[ServiceProviderCosts] RESET_DIRECT_COST_HISTORY'
export type RESET_DIRECT_COST_HISTORY = typeof RESET_DIRECT_COST_HISTORY

export const GET_PASS_TROUGH_COST_HISTORY = '[ServiceProviderCosts] GET_PASS_TROUGH_COST_HISTORY'
export type GET_PASS_TROUGH_COST_HISTORY = typeof GET_PASS_TROUGH_COST_HISTORY

export const GET_PASS_TROUGH_COST_HISTORY_SUCCESS = '[ServiceProviderCosts] GET_PASS_TROUGH_COST_HISTORY_SUCCESS'
export type GET_PASS_TROUGH_COST_HISTORY_SUCCESS = typeof GET_PASS_TROUGH_COST_HISTORY_SUCCESS

export const RESET_PASS_TROUGH_COST_HISTORY = '[ServiceProviderCosts] RESET_PASS_TROUGH_COST_HISTORY'
export type RESET_PASS_TROUGH_COST_HISTORY = typeof RESET_PASS_TROUGH_COST_HISTORY

export const UPDATE_DIRECT_COSTS = '[ServiceProviderCosts] UPDATE_DIRECT_COSTS'
export type UPDATE_DIRECT_COSTS = typeof UPDATE_DIRECT_COSTS

export const UPDATE_DIRECT_COSTS_SUCCESS = '[ServiceProviderCosts] UPDATE_DIRECT_COSTS_SUCCESS'
export type UPDATE_DIRECT_COSTS_SUCCESS = typeof UPDATE_DIRECT_COSTS_SUCCESS

export const UPDATE_PASS_TROUGH_COSTS = '[ServiceProviderCosts] UPDATE_PASS_TROUGH_COSTS'
export type UPDATE_PASS_TROUGH_COSTS = typeof UPDATE_PASS_TROUGH_COSTS

export const UPDATE_PASS_TROUGH_COSTS_SUCCESS = '[ServiceProviderCosts] UPDATE_PASS_TROUGH_COSTS_SUCCESS'
export type UPDATE_PASS_TROUGH_COSTS_SUCCESS = typeof UPDATE_PASS_TROUGH_COSTS_SUCCESS

export const SET_BULK_DIRECT_COSTS = '[ServiceProviderCosts] SET_BULK_DIRECT_COSTS'
export type SET_BULK_DIRECT_COSTS = typeof SET_BULK_DIRECT_COSTS

export const SET_OFFER_BULK_DIRECT_COSTS = '[ServiceProviderCosts] SET_OFFER_BULK_DIRECT_COSTS'
export type SET_OFFER_BULK_DIRECT_COSTS = typeof SET_OFFER_BULK_DIRECT_COSTS

export const GET_OFFER_DIRECT_COSTS = '[ServiceProviderCosts] GET_OFFER_DIRECT_COSTS'
export type GET_OFFER_DIRECT_COSTS = typeof GET_OFFER_DIRECT_COSTS

export const GET_OFFER_DIRECT_COSTS_SUCCESS = '[ServiceProviderCosts] GET_OFFER_DIRECT_COSTS_SUCCESS'
export type GET_OFFER_DIRECT_COSTS_SUCCESS = typeof GET_OFFER_DIRECT_COSTS_SUCCESS

export const GET_OFFER_PASS_TROUGH_COSTS = '[ServiceProviderCosts] GET_OFFER_PASS_TROUGH_COSTS'
export type GET_OFFER_PASS_TROUGH_COSTS = typeof GET_OFFER_PASS_TROUGH_COSTS

export const GET_OFFER_PASS_TROUGH_COSTS_SUCCESS = '[ServiceProviderCosts] GET_OFFER_PASS_TROUGH_COSTS_SUCCESS'
export type GET_OFFER_PASS_TROUGH_COSTS_SUCCESS = typeof GET_OFFER_PASS_TROUGH_COSTS_SUCCESS

export const UPDATE_OFFER_DIRECT_COSTS = '[ServiceProviderCosts] UPDATE_OFFER_DIRECT_COSTS'
export type UPDATE_OFFER_DIRECT_COSTS = typeof UPDATE_OFFER_DIRECT_COSTS

export const UPDATE_OFFER_DIRECT_COSTS_SUCCESS = '[ServiceProviderCosts] UPDATE_OFFER_DIRECT_COSTS_SUCCESS'
export type UPDATE_OFFER_DIRECT_COSTS_SUCCESS = typeof UPDATE_OFFER_DIRECT_COSTS_SUCCESS

export const UPDATE_OFFER_PASS_TROUGH_COSTS = '[ServiceProviderCosts] UPDATE_OFFER_PASS_TROUGH_COSTS'
export type UPDATE_OFFER_PASS_TROUGH_COSTS = typeof UPDATE_OFFER_PASS_TROUGH_COSTS

export const UPDATE_OFFER_PASS_TROUGH_COSTS_SUCCESS = '[ServiceProviderCosts] UPDATE_OFFER_PASS_TROUGH_COSTS_SUCCESS'
export type UPDATE_OFFER_PASS_TROUGH_COSTS_SUCCESS = typeof UPDATE_OFFER_PASS_TROUGH_COSTS_SUCCESS

export const SET_BULK_PASS_TROUGH_COSTS = '[ServiceProviderCosts] SET_BULK_PASS_TROUGH_COSTS'
export type SET_BULK_PASS_TROUGH_COSTS = typeof SET_BULK_PASS_TROUGH_COSTS

export const SET_OFFER_BULK_PASS_THROUGH_COSTS = '[ServiceProviderCosts] SET_OFFER_BULK_PASS_THROUGH_COSTS'
export type SET_OFFER_BULK_PASS_THROUGH_COSTS = typeof SET_OFFER_BULK_PASS_THROUGH_COSTS

export type SET_COST_DATES_SUCCESS = typeof SET_COST_DATES_SUCCESS
export const SET_COST_DATES_SUCCESS = '[Projects] SET_COST_DATES_SUCCESS'

export const SET_ACTIVE_SPT_BUDGET_TAB = '[ServiceProviderCosts] SET_ACTIVE_SPT_BUDGET_TAB'
export type SET_ACTIVE_SPT_BUDGET_TAB = typeof SET_ACTIVE_SPT_BUDGET_TAB

export const DELETE_OFFER_VERSION = '[ServiceProviderCosts] DELETE_OFFER_VERSION'
export type DELETE_OFFER_VERSION = typeof DELETE_OFFER_VERSION

export const DELETE_OFFER_VERSION_SUCCESS = '[ServiceProviderCosts] DELETE_OFFER_VERSION_SUCCESS'
export type DELETE_OFFER_VERSION_SUCCESS = typeof DELETE_OFFER_VERSION_SUCCESS

export const SET_DRAGGABLE_INDICATOR_SUCCESS = '[ServiceProviderCosts] SET_DRAGGABLE_INDICATOR_SUCCESS'
export type SET_DRAGGABLE_INDICATOR_SUCCESS = typeof SET_DRAGGABLE_INDICATOR_SUCCESS

export const EXPORT_PROJECT_DIRECT_COSTS = '[ServiceProviderCosts] EXPORT_PROJECT_DIRECT_COSTS'
export type EXPORT_PROJECT_DIRECT_COSTS = typeof EXPORT_PROJECT_DIRECT_COSTS

export const EXPORT_PROJECT_DIRECT_COSTS_SUCCESS = '[ServiceProviderCosts] EXPORT_PROJECT_DIRECT_COSTS_SUCCESS'
export type EXPORT_PROJECT_DIRECT_COSTS_SUCCESS = typeof EXPORT_PROJECT_DIRECT_COSTS_SUCCESS

export const SET_MILESTONE_VIEW_SUCCESS = '[ServiceProviderCosts] SET_MILESTONE_VIEW_SUCCESS'
export type SET_MILESTONE_VIEW_SUCCESS = typeof SET_MILESTONE_VIEW_SUCCESS

export const SET_MILESTONE_SORT_SUCCESS = '[ServiceProviderCosts] SET_MILESTONE_SORT_SUCCESS'
export type SET_MILESTONE_SORT_SUCCESS = typeof SET_MILESTONE_SORT_SUCCESS

export const GET_MILESTONE_OFFER_DIRECT_COSTS = '[ServiceProviderCosts] GET_MILESTONE_OFFER_DIRECT_COSTS'
export type GET_MILESTONE_OFFER_DIRECT_COSTS = typeof GET_MILESTONE_OFFER_DIRECT_COSTS

export const GET_MILESTONE_OFFER_DIRECT_COSTS_SUCCESS = '[ServiceProviderCosts] GET_MILESTONE_OFFER_DIRECT_COSTS_SUCCESS'
export type GET_MILESTONE_OFFER_DIRECT_COSTS_SUCCESS = typeof GET_MILESTONE_OFFER_DIRECT_COSTS_SUCCESS

export const GET_MILESTONES = '[ServiceProviderCosts] GET_MILESTONES'
export type GET_MILESTONES = typeof GET_MILESTONES

export const GET_MILESTONES_SUCCESS = '[ServiceProviderCosts] GET_MILESTONES_SUCCESS'
export type GET_MILESTONES_SUCCESS = typeof GET_MILESTONES_SUCCESS

export const DELETE_MILESTONE = '[ServiceProviderCosts] DELETE_MILESTONE'
export type DELETE_MILESTONE = typeof DELETE_MILESTONE

export const DELETE_MILESTONE_SUCCESS = '[ServiceProviderCosts] DELETE_MILESTONE_SUCCESS'
export type DELETE_MILESTONE_SUCCESS = typeof DELETE_MILESTONE_SUCCESS

export const GET_MILESTONE = '[ServiceProviderCosts] GET_MILESTONE'
export type GET_MILESTONE = typeof GET_MILESTONE

export const GET_MILESTONE_SUCCESS = '[ServiceProviderCosts] GET_MILESTONE_SUCCESS'
export type GET_MILESTONE_SUCCESS = typeof GET_MILESTONE_SUCCESS

export const CREATE_MILESTONE = '[ServiceProviderCosts] CREATE_MILESTONE'
export type CREATE_MILESTONE = typeof CREATE_MILESTONE

export const CREATE_MILESTONE_SUCCESS = '[ServiceProviderCosts] CREATE_MILESTONE_SUCCESS'
export type CREATE_MILESTONE_SUCCESS = typeof CREATE_MILESTONE_SUCCESS

export const UPDATE_MILESTONE = '[ServiceProviderCosts] UPDATE_MILESTONE'
export type UPDATE_MILESTONE = typeof UPDATE_MILESTONE

export const UPDATE_MILESTONE_SUCCESS = '[ServiceProviderCosts] UPDATE_MILESTONE_SUCCESS'
export type UPDATE_MILESTONE_SUCCESS = typeof UPDATE_MILESTONE_SUCCESS

export const SET_MILESTONE_OFFER_DIRECT_COSTS_UPDATE_SUCCESS = '[ServiceProviderCosts] SET_MILESTONE_OFFER_DIRECT_COSTS_UPDATE_SUCCESS'
export type SET_MILESTONE_OFFER_DIRECT_COSTS_UPDATE_SUCCESS = typeof SET_MILESTONE_OFFER_DIRECT_COSTS_UPDATE_SUCCESS

export const MILESTONE_OFFER_DIRECT_COSTS_UPDATE = '[ServiceProviderCosts] MILESTONE_OFFER_DIRECT_COSTS_UPDATE'
export type MILESTONE_OFFER_DIRECT_COSTS_UPDATE = typeof MILESTONE_OFFER_DIRECT_COSTS_UPDATE

export const MILESTONE_OFFER_DIRECT_COSTS_UPDATE_SUCCESS = '[ServiceProviderCosts] MILESTONE_OFFER_DIRECT_COSTS_UPDATE_SUCCESS'
export type MILESTONE_OFFER_DIRECT_COSTS_UPDATE_SUCCESS = typeof MILESTONE_OFFER_DIRECT_COSTS_UPDATE_SUCCESS

export const MILESTONE_OFFER_DIRECT_COSTS_RESET = '[ServiceProviderCosts] MILESTONE_OFFER_DIRECT_COSTS_RESET'
export type MILESTONE_OFFER_DIRECT_COSTS_RESET = typeof MILESTONE_OFFER_DIRECT_COSTS_RESET

export const GET_MILESTONE_UNIT_TRACKER = '[ServiceProviderCosts] GET_MILESTONE_UNIT_TRACKER'
export type GET_MILESTONE_UNIT_TRACKER = typeof GET_MILESTONE_UNIT_TRACKER

export const GET_MILESTONE_UNIT_TRACKER_SUCCESS = '[ServiceProviderCosts] GET_MILESTONE_UNIT_TRACKER_SUCCESS'
export type GET_MILESTONE_UNIT_TRACKER_SUCCESS = typeof GET_MILESTONE_UNIT_TRACKER_SUCCESS

/** BUDGET COSTS */
export const BUDGET_SIDEBAR = '[Project] BUDGET_SIDEBAR'
export type BUDGET_SIDEBAR = typeof BUDGET_SIDEBAR

export const COSTS_HAS_ERRORED = '[Project] COSTS_HAS_ERRORED'
export type COSTS_HAS_ERRORED = typeof COSTS_HAS_ERRORED

export const GET_COSTS = '[Project] GET_COSTS'
export type GET_COSTS = typeof GET_COSTS

export const GET_COSTS_SUCCESS = '[Project] GET_COSTS_SUCCESS'
export type GET_COSTS_SUCCESS = typeof GET_COSTS_SUCCESS

export const GET_COSTS_OUTSTANDING = '[Project] GET_COSTS_OUTSTANDING'
export type GET_COSTS_OUTSTANDING = typeof GET_COSTS_OUTSTANDING

export const GET_COSTS_OUTSTANDING_SUCCESS = '[Project] GET_COSTS_OUTSTANDING_SUCCESS'
export type GET_COSTS_OUTSTANDING_SUCCESS = typeof GET_COSTS_OUTSTANDING_SUCCESS

export const GET_PAGINATED_COSTS_OUTSTANDING = '[Project] GET_PAGINATED_COSTS_OUTSTANDING'
export type GET_PAGINATED_COSTS_OUTSTANDING = typeof GET_PAGINATED_COSTS_OUTSTANDING

export const GET_PAGINATED_COSTS_OUTSTANDING_SUCCESS = '[Project] GET_PAGINATED_COSTS_OUTSTANDING_SUCCESS'
export type GET_PAGINATED_COSTS_OUTSTANDING_SUCCESS = typeof GET_PAGINATED_COSTS_OUTSTANDING_SUCCESS

export const SET_PAGINATED_COSTS_OUTSTANDING_ACTIVE_PAGE = '[Project] SET_PAGINATED_COSTS_OUTSTANDING_ACTIVE_PAGE'
export type SET_PAGINATED_COSTS_OUTSTANDING_ACTIVE_PAGE = typeof SET_PAGINATED_COSTS_OUTSTANDING_ACTIVE_PAGE

export const GET_COSTS_CHART = '[Project] GET_COSTS_CHART'
export type GET_COSTS_CHART = typeof GET_COSTS_CHART

export const GET_COSTS_CHART_SUCCESS = '[Project] GET_COSTS_CHART_SUCCESS'
export type GET_COSTS_CHART_SUCCESS = typeof GET_COSTS_CHART_SUCCESS

export const GET_COST = '[Project] GET_COST'
export type GET_COST = typeof GET_COST

export const GET_COST_SUCCESS = '[Project] GET_COST_SUCCESS'
export type GET_COST_SUCCESS = typeof GET_COST_SUCCESS

export const CREATE_COST = '[Project] CREATE_COST'
export type CREATE_COST = typeof CREATE_COST

export const CREATE_COST_SUCCESS = '[Project] CREATE_COST_SUCCESS'
export type CREATE_COST_SUCCESS = typeof CREATE_COST_SUCCESS

export const UPDATE_COST = '[Project] UPDATE_COST'
export type UPDATE_COST = typeof UPDATE_COST

export const UPDATE_COST_SUCCESS = '[Project] UPDATE_COST_SUCCESS'
export type UPDATE_COST_SUCCESS = typeof UPDATE_COST_SUCCESS

export const DELETE_COST = '[Project] DELETE_COST'
export type DELETE_COST = typeof DELETE_COST

export const DELETE_COST_SUCCESS = '[Project] DELETE_COST_SUCCESS'
export type DELETE_COST_SUCCESS = typeof DELETE_COST_SUCCESS

/** ACCOUNTING */

export const SELECT_ACCOUTING_TAB = '[Project] SELECT_ACCOUTING_TAB'
export type SELECT_ACCOUTING_TAB = typeof SELECT_ACCOUTING_TAB

export const ACCOUNTING_HAS_ERRORED = '[Project] ACCOUNTING_HAS_ERRORED'
export type ACCOUNTING_HAS_ERRORED = typeof ACCOUNTING_HAS_ERRORED

export const GET_INVOICES = '[Project] GET_INVOICES'
export type GET_INVOICES = typeof GET_INVOICES

export const GET_INVOICES_SUCCESS = '[Project] GET_INVOICES_SUCCESS'
export type GET_INVOICES_SUCCESS = typeof GET_INVOICES_SUCCESS

export const GET_INVOICE = '[Project] GET_INVOICE'
export type GET_INVOICE = typeof GET_INVOICE

export const GET_INVOICE_SUCCESS = '[Project] GET_INVOICE_SUCCESS'
export type GET_INVOICE_SUCCESS = typeof GET_INVOICE_SUCCESS

export const CREATE_INVOICE = '[Project] CREATE_INVOICE'
export type CREATE_INVOICE = typeof CREATE_INVOICE

export const CREATE_INVOICE_SUCCESS = '[Project] CREATE_INVOICE_SUCCESS'
export type CREATE_INVOICE_SUCCESS = typeof CREATE_INVOICE_SUCCESS

export const UPDATE_INVOICE = '[Project] UPDATE_INVOICE'
export type UPDATE_INVOICE = typeof UPDATE_INVOICE

export const UPDATE_INVOICE_SUCCESS = '[Project] UPDATE_INVOICE_SUCCESS'
export type UPDATE_INVOICE_SUCCESS = typeof UPDATE_INVOICE_SUCCESS

export const DELETE_INVOICE = '[Project] DELETE_INVOICE'
export type DELETE_INVOICE = typeof DELETE_INVOICE

export const DELETE_INVOICE_SUCCESS = '[Project] DELETE_INVOICE_SUCCESS'
export type DELETE_INVOICE_SUCCESS = typeof DELETE_INVOICE_SUCCESS

export const SET_SELECTED_INVOICE = '[Project] SET_SELECTED_INVOICE'
export type SET_SELECTED_INVOICE = typeof SET_SELECTED_INVOICE

export const SORT_INVOICES = '[Project] SORT_INVOICES'
export type SORT_INVOICES = typeof SORT_INVOICES

export const GET_PAGINATED_PAYMENTS = '[Project] GET_PAGINATED_PAYMENTS'
export type GET_PAGINATED_PAYMENTS = typeof GET_PAGINATED_PAYMENTS

export const GET_PAGINATED_PAYMENTS_SUCCESS = '[Project] GET_PAGINATED_PAYMENTS_SUCCESS'
export type GET_PAGINATED_PAYMENTS_SUCCESS = typeof GET_PAGINATED_PAYMENTS_SUCCESS

export const GET_PAYMENTS = '[Project] GET_PAYMENTS'
export type GET_PAYMENTS = typeof GET_PAYMENTS

export const GET_PAYMENTS_SUCCESS = '[Project] GET_PAYMENTS_SUCCESS'
export type GET_PAYMENTS_SUCCESS = typeof GET_PAYMENTS_SUCCESS

export const SORT_PAYMENTS = '[Project] SORT_PAYMENTS'
export type SORT_PAYMENTS = typeof SORT_PAYMENTS

export const SET_PAGINATED_PAYMENTS_ACTIVE_PAGE = '[Project] SET_PAGINATED_PAYMENTS_ACTIVE_PAGE'
export type SET_PAGINATED_PAYMENTS_ACTIVE_PAGE = typeof SET_PAGINATED_PAYMENTS_ACTIVE_PAGE

export const GET_PAGINATED_INVOICES = '[Project] GET_PAGINATED_INVOICES'
export type GET_PAGINATED_INVOICES = typeof GET_PAGINATED_INVOICES

export const GET_PAGINATED_INVOICES_SUCCESS = '[Project] GET_PAGINATED_INVOICES_SUCCESS'
export type GET_PAGINATED_INVOICES_SUCCESS = typeof GET_PAGINATED_INVOICES_SUCCESS

export const SET_PAGINATED_INVOICES_ACTIVE_PAGE = '[Project] SET_PAGINATED_INVOICES_ACTIVE_PAGE'
export type SET_PAGINATED_INVOICES_ACTIVE_PAGE = typeof SET_PAGINATED_INVOICES_ACTIVE_PAGE

export const GET_LATEST_PAYMENTS = '[Project] GET_LATEST_PAYMENTS'
export type GET_LATEST_PAYMENTS = typeof GET_LATEST_PAYMENTS

export const GET_LATEST_PAYMENTS_SUCCESS = '[Project] GET_LATEST_PAYMENTS_SUCCESS'
export type GET_LATEST_PAYMENTS_SUCCESS = typeof GET_LATEST_PAYMENTS_SUCCESS

/* Scheduled Payments */
export const GET_DIRECT_COST_INVOICES = '[Project] GET_DIRECT_COST_INVOICES'
export type GET_DIRECT_COST_INVOICES = typeof GET_DIRECT_COST_INVOICES

export const GET_DIRECT_COST_INVOICES_SUCCESS = '[Project] GET_DIRECT_COST_INVOICES_SUCCESS'
export type GET_DIRECT_COST_INVOICES_SUCCESS = typeof GET_DIRECT_COST_INVOICES_SUCCESS

export const GET_DIRECT_COST_INVOICE = '[Project] GET_DIRECT_COST_INVOICE'
export type GET_DIRECT_COST_INVOICE = typeof GET_DIRECT_COST_INVOICE

export const GET_DIRECT_COST_INVOICE_SUCCESS = '[Project] GET_DIRECT_COST_INVOICE_SUCCESS'
export type GET_DIRECT_COST_INVOICE_SUCCESS = typeof GET_DIRECT_COST_INVOICE_SUCCESS

export const CREATE_DIRECT_COST_INVOICE = '[Project] CREATE_DIRECT_COST_INVOICE'
export type CREATE_DIRECT_COST_INVOICE = typeof CREATE_DIRECT_COST_INVOICE

export const CREATE_DIRECT_COST_INVOICE_SUCCESS = '[Project] CREATE_DIRECT_COST_INVOICE_SUCCESS'
export type CREATE_DIRECT_COST_INVOICE_SUCCESS = typeof CREATE_DIRECT_COST_INVOICE_SUCCESS

export const UPDATE_DIRECT_COST_INVOICE = '[Project] UPDATE_DIRECT_COST_INVOICE'
export type UPDATE_DIRECT_COST_INVOICE = typeof UPDATE_DIRECT_COST_INVOICE

export const UPDATE_DIRECT_COST_INVOICE_SUCCESS = '[Project] UPDATE_DIRECT_COST_INVOICE_SUCCESS'
export type UPDATE_DIRECT_COST_INVOICE_SUCCESS = typeof UPDATE_DIRECT_COST_INVOICE_SUCCESS

export const DELETE_DIRECT_COST_INVOICE = '[Project] DELETE_DIRECT_COST_INVOICE'
export type DELETE_DIRECT_COST_INVOICE = typeof DELETE_DIRECT_COST_INVOICE

export const DELETE_DIRECT_COST_INVOICE_SUCCESS = '[Project] DELETE_DIRECT_COST_INVOICE_SUCCESS'
export type DELETE_DIRECT_COST_INVOICE_SUCCESS = typeof DELETE_DIRECT_COST_INVOICE_SUCCESS

export const SET_SELECTED_DIRECT_COST_INVOICE = '[Project] SET_SELECTED_DIRECT_COST_INVOICE'
export type SET_SELECTED_DIRECT_COST_INVOICE = typeof SET_SELECTED_DIRECT_COST_INVOICE

export const SORT_DIRECT_COST_INVOICES = '[Project] SORT_DIRECT_COST_INVOICES'
export type SORT_DIRECT_COST_INVOICES = typeof SORT_DIRECT_COST_INVOICES

/* Customers */
export const GET_CUSTOMERS = '[Project] GET_CUSTOMERS'
export type GET_CUSTOMERS = typeof GET_CUSTOMERS

export const GET_CUSTOMERS_SUCCESS = '[Project] GET_CUSTOMERS_SUCCESS'
export type GET_CUSTOMERS_SUCCESS = typeof GET_CUSTOMERS_SUCCESS

export const SORT_PTC = '[Project] SORT_PTC'
export type SORT_PTC = typeof SORT_PTC
